import React, { useEffect, useState, useRef } from 'react'
import { useIntl } from 'react-intl'
import ClampLines from 'react-clamp-lines'
import Link from '../Link'
import WpTags from '../WpTags'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import {
  previewCard,
  hero,
  titleContainer,
  date,
  title,
  description,
  ousterBlogPreviewCard,
  author,
  authorDateContainer,
} from './index.module.css'

import {
  getLocaleData,
  mapLocaleData,
  decodeHtml,
  isSvgOrGif,
} from '../../utils'

const WpBlogPostPreview = ({ data, defaultdata, location }) => {
  const intl = useIntl()
  const mutatedData = data
  const tags = data.tags.nodes.map((tag) => tag)
  const defaultAuthor = intl.formatMessage({ id: 'blog.defaultAuthor' })
  const homeUrl = intl.formatMessage({ id: 'blog.homeUrl' })
  const authorName = mutatedData.author.node.userProfile.authorProfile
    ? mutatedData.author.node.userProfile.authorProfile.title
    : defaultAuthor
  const [content, setContent] = useState(
    mutatedData.postOptions.metaDescription
      ? mutatedData.postOptions.metaDescription
      : mutatedData.excerpt
  )

  useEffect(() => {
    setContent(
      decodeHtml(
        mutatedData.postOptions.metaDescription
          ? mutatedData.postOptions.metaDescription
          : mutatedData.excerpt
      )
    )
  }, [])

  return (
    <div className={ousterBlogPreviewCard}>
      <div className={previewCard}>
        <Link
          to={`${homeUrl}${mutatedData.slug + '/'}`}
          className={ousterBlogPreviewCard}
        >
          <div className={hero}>
            {mutatedData.featuredImage &&
            mutatedData.featuredImage.node.localFile.previewCardImage ? (
              <GatsbyImage
                image={getImage(
                  mutatedData.featuredImage.node.localFile.previewCardImage
                )}
                alt={mutatedData?.featuredImage?.node?.altText}
              />
            ) : isSvgOrGif(
                mutatedData?.featuredImage?.node?.localFile?.publicURL
              ) ? (
              <img
                src={mutatedData?.featuredImage?.node?.localFile?.publicURL}
                alt={mutatedData?.featuredImage?.node?.altText}
              />
            ) : (
              <GatsbyImage
                image={getImage(
                  defaultdata.authorBannerDefault.localFile.previewCardImage
                )}
                alt={defaultdata?.authorBannerDefault?.altText}
              />
            )}
          </div>
        </Link>

        {tags.length > 0 && <WpTags tags={tags} location={location} />}

        <div className={titleContainer}>
          <h3 className={title}>
            <Link to={`${homeUrl}${mutatedData.slug + '/'}`}>
              {mutatedData.title}
            </Link>
          </h3>
          <div className={authorDateContainer}>
            <Link to={`${homeUrl}${mutatedData.slug + '/'}`} className={date}>
              {mutatedData.date}&nbsp;—&nbsp;
            </Link>
            {mutatedData.author.node.userProfile.authorProfile ? (
              <Link
                to={`${homeUrl}author/${
                  mutatedData.author.node.userProfile.authorProfile.slug + '/'
                }`}
                className={author}
              >
                {authorName}
              </Link>
            ) : (
              <Link
                to={`${homeUrl}${mutatedData.slug + '/'}`}
                className={author}
              >
                {authorName}
              </Link>
            )}
          </div>
        </div>
        <Link to={`${homeUrl}${mutatedData.slug + '/'}`}>
          <ClampLines
            className={description}
            lines={4}
            text={content}
            innerElement="div"
            buttons={false}
            stopPropagation={true}
          />
        </Link>
      </div>
    </div>
  )
}

export default WpBlogPostPreview
